import { Action } from '@ngrx/store';

import {
  EnrollKydOperatorPayload,
  EnrollKydPolicyData,
  UpdateKydOperatorPhonePayload
} from '../models/kyd-partial-household.model';

export enum KydPartialHouseholdActionTypes {
  EnrollPolicy = '[KydPartialHousehold] Enroll Policy',
  EnrollPolicyAllOperatorsSuccess = '[KydPartialHousehold] Enroll Policy All Operators Success',
  EnrollPolicySingleOperatorSuccess = '[KydPartialHousehold] Enroll Policy Single Operator Success',
  EnrollPolicyFail = '[KydPartialHousehold] Enroll Policy Fail',

  UnenrollPolicy = '[KydPartialHousehold] Unenroll Policy',
  UnenrollPolicySuccess = '[KydPartialHousehold] Unenroll Policy Success',
  UnenrollPolicyFail = '[KydPartialHousehold] Unenroll Policy Fail',

  EnrollOperator = '[KydPartialHousehold] Enroll Operator',
  EnrollOperatorSuccess = '[KydPartialHousehold] Enroll Operator Success',
  EnrollOperatorFail = '[KydPartialHousehold] Enroll Operator Fail',

  UnenrollOperator = '[KydPartialHousehold] Unenroll Operator',
  UnenrollOperatorSuccess = '[KydPartialHousehold] Unenroll Operator Success',
  UnenrollOperatorFail = '[KydPartialHousehold] Unenroll Operator Fail',

  UpdateOperatorPhoneNumber = '[KydPartialHousehold] Update Operator Phone Number',
  UpdateOperatorPhoneNumberSuccess = '[KydPartialHousehold] Update Operator Phone Number Success',
  UpdateOperatorPhoneNumberFail = '[KydPartialHousehold] Update Operator Phone Number Fail',

  ResetState = '[KydPartialHousehold] Reset State'
}

export class EnrollPolicy implements Action {
  readonly type = KydPartialHouseholdActionTypes.EnrollPolicy;
  constructor(public payload: EnrollKydPolicyData) {}
}

export class EnrollPolicyAllOperatorsSuccess implements Action {
  readonly type = KydPartialHouseholdActionTypes.EnrollPolicyAllOperatorsSuccess;
  constructor(public payload?: any) {}
}

export class EnrollPolicySingleOperatorSuccess implements Action {
  readonly type = KydPartialHouseholdActionTypes.EnrollPolicySingleOperatorSuccess;
  constructor(public payload: string) {}
}

export class EnrollPolicyFail implements Action {
  readonly type = KydPartialHouseholdActionTypes.EnrollPolicyFail;
  constructor(public payload: any) {}
}

export class UnenrollPolicy implements Action {
  readonly type = KydPartialHouseholdActionTypes.UnenrollPolicy;
  constructor(public payload: { eligibleForUtah: boolean }) {}
}

export class UnenrollPolicySuccess implements Action {
  readonly type = KydPartialHouseholdActionTypes.UnenrollPolicySuccess;
  constructor(public payload?: any) {}
}

export class UnenrollPolicyFail implements Action {
  readonly type = KydPartialHouseholdActionTypes.UnenrollPolicyFail;
  constructor(public payload: any) {}
}

export class EnrollOperator implements Action {
  readonly type = KydPartialHouseholdActionTypes.EnrollOperator;
  constructor(public payload: EnrollKydOperatorPayload) {}
}
export class EnrollOperatorSuccess implements Action {
  readonly type = KydPartialHouseholdActionTypes.EnrollOperatorSuccess;
  constructor(public payload: string) {}
}

export class EnrollOperatorFail implements Action {
  readonly type = KydPartialHouseholdActionTypes.EnrollOperatorFail;
  constructor(public payload: any) {}
}

export class UnenrollOperator implements Action {
  readonly type = KydPartialHouseholdActionTypes.UnenrollOperator;
  constructor(public payload: EnrollKydOperatorPayload) {}
}

export class UnenrollOperatorSuccess implements Action {
  readonly type = KydPartialHouseholdActionTypes.UnenrollOperatorSuccess;
  constructor(public payload: string) {}
}

export class UnenrollOperatorFail implements Action {
  readonly type = KydPartialHouseholdActionTypes.UnenrollOperatorFail;
  constructor(public payload: any) {}
}

export class UpdateOperatorPhoneNumber implements Action {
  readonly type = KydPartialHouseholdActionTypes.UpdateOperatorPhoneNumber;
  constructor(public payload: UpdateKydOperatorPhonePayload) {}
}

export class UpdateOperatorPhoneNumberSuccess implements Action {
  readonly type = KydPartialHouseholdActionTypes.UpdateOperatorPhoneNumberSuccess;
  constructor(public payload?: any) {}
}

export class UpdateOperatorPhoneNumberFail implements Action {
  readonly type = KydPartialHouseholdActionTypes.UpdateOperatorPhoneNumberFail;
  constructor(public payload: any) {}
}

export class ResetState implements Action {
  readonly type = KydPartialHouseholdActionTypes.ResetState;
  constructor(public payload?: any) {}
}

export type KydPartialHouseholdActions =
  | EnrollPolicy
  | EnrollPolicyAllOperatorsSuccess
  | EnrollPolicySingleOperatorSuccess
  | EnrollPolicyFail
  | UnenrollPolicy
  | UnenrollPolicySuccess
  | UnenrollPolicyFail
  | EnrollOperator
  | EnrollOperatorSuccess
  | EnrollOperatorFail
  | UnenrollOperator
  | UnenrollOperatorSuccess
  | UnenrollOperatorFail
  | UpdateOperatorPhoneNumber
  | UpdateOperatorPhoneNumberSuccess
  | UpdateOperatorPhoneNumberFail
  | ResetState;

export const fromKydPartialHouseholdActions = {
  EnrollPolicy,
  EnrollPolicyAllOperatorsSuccess,
  EnrollPolicySingleOperatorSuccess,
  EnrollPolicyFail,
  UnenrollPolicy,
  UnenrollPolicySuccess,
  UnenrollPolicyFail,
  EnrollOperator,
  EnrollOperatorSuccess,
  EnrollOperatorFail,
  UnenrollOperator,
  UnenrollOperatorSuccess,
  UnenrollOperatorFail,
  UpdateOperatorPhoneNumber,
  UpdateOperatorPhoneNumberSuccess,
  UpdateOperatorPhoneNumberFail,
  ResetState
};
